/* eslint-disable */
import * as Types from '../../../../../../generated/graphql'

import { gql } from '@apollo/client'
export type GQLMyTeamoTestFragment = {
  __typename?: 'My'
  teamo?: {
    __typename?: 'MyTeamo'
    surveyResults?: Array<{
      __typename?: 'TeamoPeculiarity'
      id: number
      points: number
      title: string
      description: string
    }> | null
  } | null
}

export const MyTeamoTestFragmentDoc = gql`
  fragment MyTeamoTest on My {
    teamo {
      surveyResults {
        id
        points
        title
        description
      }
    }
  }
`
